import Settings from "./settings.service";
import {milisecondstoMinutes, getUnitValuePairFromBytes} from "./helpers";

var prefix = Settings.plans_prefix;

// const checkPlanInterface = (processedPlan) => {};

const processPackagePlan = (pack, allsubplans) => {

	let subplans_ids = pack.Plans.sort();

	let subplans_by_type = {};

	let package_subplans = {};

	for (let subplan_id of subplans_ids) {

		let subplan = allsubplans[subplan_id];

		subplans_by_type[subplan.Type] = subplan_id;
		package_subplans[subplan_id] = subplan;
	}

	delete pack["Plans"];

	pack[prefix + "subplans_ids_sorted"] = subplans_ids;
	pack[prefix + "subplans_ids_by_type"] = subplans_by_type;
	pack[prefix + "subplans"] = package_subplans;

	return pack;
};

const processAvailablePlansAPI = (response) => {
	let byProductCode = {};

	for (let productGroup of response) {
		byProductCode[productGroup.ProductCode] = {};

		let subplans = {};
		for (let subplan of productGroup.AvailablePlans) {
			let final_sub = processSubPlan(subplan);
			subplans[subplan.ID] = final_sub;
		}

		let packages = {};

		for (let pack of productGroup.PackagesPricingTable) {

			let packageProcessed = processPackagePlan(pack, subplans);

			let lookup_id = packageProcessed[prefix + "subplans_ids_sorted"];

			packages[lookup_id.join(",")] = packageProcessed;
		}

		// let locked_plans = processLockedPlans(
		// 	productGroup.locked_plans
		// );

		byProductCode[productGroup.ProductCode][prefix + "subplans"] = subplans;
		byProductCode[productGroup.ProductCode][prefix + "promotions"] =
			productGroup.Promotions;
		byProductCode[productGroup.ProductCode][prefix + "packages"] = packages;
		// byProductCode[productGroup.ProductCode][
		// 	prefix + "locked_plans"
		// ] = locked_plans;
	}

	return byProductCode;
};

const processSavedPlan = (pack) => {
	let subplans_ids = [];
	let subplans = {};
	for (let subplan of pack.Plans) {
		subplans[subplan.ID] = processSubPlan(subplan);
		subplans_ids.push(subplan.ID);
	}

	subplans_ids = subplans_ids.sort();
	let subplans_by_type = {};
	for (let subplans_id of subplans_ids) {
		let subplan = subplans[subplans_id];
		subplans_by_type[subplan.Type] = subplans_id;
	}
	pack[prefix + "subplans_ids_sorted"] = subplans_ids;
	pack[prefix + "subplans_ids_by_type"] = subplans_by_type;
	pack[prefix + "subplans"] = subplans;
	return pack;
};




const processSubPlan = (rawSubplan) => {
	if (rawSubplan.Value === Settings.unlimited_value) {
		rawSubplan[prefix + "ValueFormatted"] = Settings.unlimited_text;
	} else {
		if (rawSubplan.Type === "DATA") {
			let pair = getUnitValuePairFromBytes(
				rawSubplan.Value,
				true,
				false
			);
			rawSubplan[prefix + "ValueFormatted"] = pair["value"];
			rawSubplan[prefix + "UnitFormatted"] = pair["unit"];
		} else {
			rawSubplan[prefix + "ValueFormatted"] = milisecondstoMinutes(
				rawSubplan["Value"]
			);
			rawSubplan[prefix + "UnitFormatted"] = "min/SMS";
		}
	}

	return rawSubplan;
};

export {processSubPlan, processPackagePlan, processSavedPlan, processAvailablePlansAPI};
